export default {
	title: 'bluetooth',
	components: [
		{ title: 'bluetooth_settings', component: 'bluetooth_gen_2' },
		{ title: 'assigned_bluetooth_devices', component: 'assigned_bluetooth_devices_gen_2' },
		{
			title: 'remote_controls',
			component: 'bt_home_control_gen_2',
			test_user: true,
			min_ver: '1.7.4',
		},
		{
			title: 'bluetooth_rpc_tester',
			component: 'bluetooth_rpc_tester',
			test_user: true,
		},
	],
};
